import React from 'react';
import PropTypes from 'prop-types';
import EditForm from './EditForm';
import AddForm from './AddForm';
import { Tab } from './BaseForm';

const TabbedForm = (props) => {
  const { edit, ...otherProps } = props;

  if (edit) {
    return React.createElement(EditForm, otherProps);
  }

  return React.createElement(AddForm, otherProps);
};

TabbedForm.propTypes = {
  edit: PropTypes.bool.isRequired,
};

TabbedForm.Tab = Tab;

export default TabbedForm;
